import LegalPage from './LegalPage';
import { useLanguage } from '../i18n/LanguageContext';

export default function PrivacyPolicy() {
  const { t } = useLanguage();
  return (
    <LegalPage
      testId="privacy-policy-page"
      backLabel={t.legal_back}
      eyebrow={t.pp_eyebrow}
      title={t.pp_h}
      titleAccent={t.pp_h_accent}
      effective={t.legal_effective}
      intro={t.pp_intro}
      sections={t.pp_sections}
      contactPre={t.legal_contact_pre}
      contactEmail={t.legal_email}
    />
  );
}
